import type { FaireProductEntity } from "../../entity_types/product";

export const p_fqgsrbtc36: FaireProductEntity = {
  token: "p_fqgsrbtc36",
  type: "product",
  name: "Camille Dress (2S-2M-1L)",
  brandToken: "b_85a3118wke",
  brandName: "Le Bon Shoppe",
  imageUrl:
    "https://cdn.faire.com/fastly/85afe3263cf482dda11a0201e4f6aac1a868977c426923a650e42d3a33fa13b0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f24ae6f268b3aecdf0e7a4d98f8598811bcde9a771f1c3e2257c2b7b82b49026.jpeg",
    "https://cdn.faire.com/fastly/eb2073170fd17a53bbe5b0093727b6d5da03cdb32691b13dd0eb68b2c132e4ff.jpeg",
    "https://cdn.faire.com/fastly/11183a03cff21363df7ab114e0c93ea4f3efef2bcd488cfb11f7ea34abde8cf8.jpeg",
    "https://cdn.faire.com/fastly/4c6ed68be6ccf702842b73f429176cb7edb87abbbbcb0de63998811da9ab2166.jpeg",
    "https://cdn.faire.com/fastly/4759b0a0d7f178929a1a10fb8e5d7bd3e05e06b54aab0dcc611d39d891f2c5ff.jpeg",
  ],
  priceDollars: 325,
  description:
    'Why We Made This?\n\nA refined take on the classic A-line shift, the Camille Dress is designed for effortless wear. It features a graceful V-neckline and a billowing frame that offers relaxed movement. Thoughtful details like a center front pleat and side pockets elevate the silhouette, while the soft yet durable cotton-hemp blend ensures it remains a long-lasting wardrobe staple.\n\n\n\nPlease note:\n\n\nThe dyeing and washing process gives each garment unique character. Please allow for slight color and fit variation for each garment as is the beauty of garment dye and wash. Pieces with the same color name may not match exactly.\n\n\nContents: \n\n20% Hemp 80% Cotton\n\n\n\nCare Instructions:\n\nDue to the nature of pigment dye, loose pigments may remain on the surface of the garments.\n\n-Do not spot clean \n\n-Washing these garments only with like colors and in cold water\n\n- Recommend to Hang Dry for the best result, but tumble dry low heat is fine! \n\n\n\n\nApproximate Measurements: \n\nSmall: Chest 19 1/2", Length 42”\n\nMedium: Chest 20 1/2”, Length 43”\n\nLarge: Chest 21 1/2”, Length 44”\n\n\n\nModel is 5\' 6", Bust: 34", Waist: 27", Hip:36" and wearing a size small\n\n\n\nMade in China\n\n\n\nMSRP: $135 USD\n\n\n',
  tags: [],
  msrpDollars: 650,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-21T21:52:00.057Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
